<div class="file-viewer-overlay" (keydown)="onKeydown($event)" tabindex="0">
  <div class="file-viewer-header">
    <h2>{{files[currentIndex]?.name}}</h2>
    <div class="header-actions">
      <mat-icon (click)="downloadFile()" class="action-icon download-icon" matTooltip="Download file">file_download</mat-icon>
      <mat-icon (click)="closeViewer()" class="action-icon close-icon">close</mat-icon>
    </div>
  </div>
  
  <div class="file-viewer-content">
    @if(files.length > 1) {
      <button mat-icon-button class="nav-button prev" (click)="previousFile()">
        <mat-icon>navigate_before</mat-icon>
      </button>
    }
    
    <div class="file-display">
      @if (isImage(files[currentIndex])) {
      <img aria-label="File preview" [src]="files[currentIndex].original_url" [alt]="files[currentIndex].name"
        class="file-image">
      } @else {
      <div class="file-icon-container">
        <mat-icon class="file-icon"
          [ngClass]="getSelectedFileIcon(files[currentIndex]).className">{{getSelectedFileIcon(files[currentIndex]).icon}}</mat-icon>
        <p>{{files[currentIndex].name}}</p>
      </div>
      }
    </div>
    @if(files.length > 1) {
      <button mat-icon-button class="nav-button next" (click)="nextFile()">
        <mat-icon>navigate_next</mat-icon>
      </button>
    }
  </div>
  
  <div class="file-viewer-footer">
    <span>{{currentIndex + 1}} / {{files.length}}</span>
  </div>
</div> 